import { Select } from 'antd';
import { sportList } from 'api/mockSportCategory';
import { useAppTranslation } from 'app/hooks';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';
import useThemes from 'hooks/useThemes';
import React, { useCallback, useEffect, useState } from 'react';

import oddsApi from 'api/oddsApi';
import axios from 'axios';
import { IMG_ALT } from 'consts/app';
import { GameResponseModel } from 'models';

const { Option } = Select;

interface ScoreBoardProps {
  className?: string;
}
type MapGameLeague = {
  [league: string]: string[];
};

const transformToMap = (response: GameResponseModel[]): MapGameLeague | null => {
  if (response.length <= 0) {
    return null;
  }
  const map: MapGameLeague = {};

  for (const { id, sport } of response) {
    const description = sport.description;

    if (!map[description]) {
      map[description] = [];
    }

    map[description].push(id);
  }

  return map;
};

const ScoreBoard: React.FunctionComponent<ScoreBoardProps> = ({ className = '' }) => {
  const { currentTheme } = useThemes();
  const t = useAppTranslation();
  const [currentSport, setCurrentSport] = useState<string>(sportList[0].lable);
  const [liveGames, setLiveGames] = useState<MapGameLeague | null>();
  const [loading, setLoading] = useState<boolean>(false);

  const getLiveGame = useCallback(
    async (needLoading: boolean) => {
      needLoading && setLoading(true);
      const params = {
        'status.equals': 'LIVE',
        sort: 'startDate,asc',
        size: 50,
        'main.equals': true,
        'isHidden.equals': false,
        'sportGroup.equals': currentSport,
      };
      const source = axios.CancelToken.source();
      const { ok, body } = await oddsApi.getGames(params, source.token);
      if (ok && body) {
        const newMap = transformToMap(body);
        if (newMap) {
          setLiveGames(newMap);
        } else {
          setLiveGames(null);
        }
      }
      setLoading(false);
    },
    [currentSport],
  );

  const handleChangeSport = (value: string) => {
    setCurrentSport(value);
  };

  useEffect(() => {
    if (!loading) {
      const idInterval = setInterval(() => {
        getLiveGame(false);
      }, 10000);
      return () => {
        clearInterval(idInterval);
      };
    }
  }, [currentSport, loading]);

  useEffect(() => {
    getLiveGame(true);
  }, [getLiveGame]);

  return (
    <div className={`${className} chat-room__chatbox score-board-container`}>
      <div className="select-game-score-board_container">
        <Select
          className="select-game-score-board"
          dropdownClassName="score-board-item primary-text-color"
          defaultValue={currentSport}
          onChange={handleChangeSport}
          optionLabelProp="label"
        >
          {sportList.map((option) => (
            <Option
              key={option.key}
              value={option.lable}
              label={
                <div className="flex-row items-center gap-1 p-1">
                  <img className="w-5 h-5" src={option.image} alt={IMG_ALT} />
                  <span className="primary-text-color">{t(option.title)}</span>
                </div>
              }
            >
              <div className="flex-row items-center gap-1 p-1">
                <img className="w-5 h-5" src={option.image} alt={IMG_ALT} />
                <span className="primary-text-color">{t(option.title)}</span>
              </div>
            </Option>
          ))}
        </Select>
      </div>
      <div className="score-board-container-list">
        {loading ? (
          <span className="spiner-loader"></span>
        ) : !liveGames ? (
          <EmptyTableIcon text={t('game.empty-live-game')} />
        ) : (
          Object.entries(liveGames).map(([league, gameIds]) => (
            <div key={league} className="list-game-score-by-league">
              <h5 className="primary-text-color">{league}</h5>
              {gameIds.map((id) => (
                <iframe
                  key={id}
                  allowTransparency
                  scrolling="no"
                  className="score-board-frame"
                  width="100%"
                  src={`https://gsm-widgets.betstream.betgenius.com/multisportscoreboard?productName=terabet${
                    currentTheme === 'dark' ? '-dark' : ''
                  }&fixtureId=${id}`}
                />
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ScoreBoard;
